/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { AnalyticsConstants, Operations, Payload } from '@tivocorp/tivo-webapp-loggers';

export class OperationsLogger {
    private static TAG: string = 'OperationsLogger';

    public static logUIErrorCode(code: string) {
        const payload = new Payload();
        payload.add(AnalyticsConstants.Fields.EVENT_NAME, 'UIErrorCode');
        payload.add('CODE', code);
        payload.add(AnalyticsConstants.Fields.REFRENCE_TIME, new Date().getTime());
        Operations.log(payload);
    }
}
